import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogService } from './confirm-dialog.service';
import { LucideIconsModule } from '../../lucide-icons.module';

@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    imports: [CommonModule, LucideIconsModule],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
    readonly confirm = inject(ConfirmDialogService);

    @HostListener('document:keydown.escape')
    onEscape() {
        if (this.confirm.isOpen()) this.confirm.resolve(false);
    }

    cancel(event?: Event): void {
        event?.stopPropagation();
        this.confirm.resolve(false);
    }

    accept(): void {
        this.confirm.resolve(true);
    }
}
